// extracted by mini-css-extract-plugin
module.exports = {"Content":"leftSide_Content__xMjrJ","BaltexH1":"leftSide_BaltexH1__cA0x4","Side":"leftSide_Side__C7wr5","Block":"leftSide_Block__YQ2PQ"};